// One conversation bubble, with the praise / correction / tip decorations the
// Android build drew in `ui/ChatScreen.kt`.
import type { ChatMessage } from '../types';

export default function MessageBubble({
  message,
  onSpeak,
}: {
  message: ChatMessage;
  onSpeak: () => void;
}) {
  const isTutor = message.role === 'tutor';
  return (
    <div className={`row ${isTutor ? 'tutor' : 'learner'}`}>
      <div className={`bubble ${isTutor ? 'tutor' : 'learner'}`}>
        {message.praise && <div className="praise">{message.praise}</div>}

        <p>{message.text}</p>

        {message.corrections?.map((correction, index) => (
          <div className="correction" key={`${correction.rule}-${index}`}>
            <div className="swap">
              ✏️ “{correction.original}” → “{correction.corrected}”
            </div>
            <div className="why">{correction.explanation}</div>
          </div>
        ))}

        {message.correctedSentence && (
          <div className="retry">Try the whole sentence again: “{message.correctedSentence}”</div>
        )}

        {message.tip && <div className="tip">💡 {message.tip}</div>}

        {isTutor && (
          <button type="button" className="hear-again" onClick={onSpeak}>
            🔊 Hear it again
          </button>
        )}
      </div>
    </div>
  );
}
